import React, { useEffect } from 'react'
import { ActivityIndicator } from 'react-native'
import { observer } from 'mobx-react-lite'
import { useHistory, useRouteMatch } from 'react-router-dom'

import { useStores } from '@trivie/core'
import { Text } from '@trivie/ui-web/components/text'
import { InfoCard } from '@trivie/ui-mobile/components/info-card'
import { IconButton, Stack, useMediaQuery } from '@mui/material'
import { ArrowBack } from '@mui/icons-material'

export const InfoCardScreen: React.FunctionComponent<any> = observer(() => {
  const history = useHistory()

  const { uiStore, cardStore } = useStores()
  const { branding } = uiStore
  const { getInfoCard, setSelectedCard, selectedCard } = cardStore

  const { params } = useRouteMatch()
  // @ts-ignore
  const { cardID } = params

  useEffect(() => {
    if (!cardID) {
      history.goBack()
    }
    setSelectedCard(undefined)
    getInfoCard(Number(cardID))
    return () => setSelectedCard(undefined)
  }, [])

  const isMobile = useMediaQuery('(max-width:800px)')
  const titleStyle = { fontSize: isMobile ? 18 : 24, color: branding.text_color }

  return (
    <div style={{ ...CONTAINER, background: branding.quiz_background }}>
      <Stack
        width="100%"
        gap={2}
        padding={2}
        alignItems="center"
        direction="row"
        justifyContent="space-between"
      >
        <IconButton onClick={history.goBack}>
          <ArrowBack htmlColor={branding.text_color} />
        </IconButton>
        <Text noWrap text={selectedCard?.card_name || ' '} variant="headline" style={titleStyle} />
        <div style={{ width: 24 }} />
      </Stack>
      {!selectedCard ? (
        <ActivityIndicator
          color="#999"
          style={{ flex: 1, height: window.innerHeight - 100 }}
          size="small"
        />
      ) : (
        <div style={CONTENT}>
          <InfoCard
            hideTitle
            branding={branding}
            containerStyle={{ padding: 20 }}
            card={selectedCard}
          />
        </div>
      )}
    </div>
  )
})

/**
 * Styling
 */

const CONTAINER: React.CSSProperties = {
  position: 'absolute',
  height: '100%',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 998,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
}
const CONTENT: React.CSSProperties = {
  flexDirection: 'column',
  justifyContent: 'center',
  display: 'flex',
  paddingBottom: 80,
  maxWidth: 800,
  overflowY: 'auto',
}
